import {first, filter, find} from 'lodash';
import {CalculatorResolver as resolver} from "app/components/calculator/calculator.resolver";
import {CalculatorProvider as provider} from "app/components/calculator/calculator.provider";
import {DeliveryMethod} from "app/model/deliveryMethod";
import {sortCountriesBySuggested} from "./helpers/sorter";

export const CalculatorSelector = {
    getDirections: (getState) => {
        const {directions} = getState().calculator;

        return {
            directions
        }
    },

    getCountries: (getState) => {
        const calculatorBase = provider.init;
        const {directions} = getState().calculator;
        const availableCountriesIn = sortCountriesBySuggested(Object.keys(directions));
        const countryIn = calculatorBase.countryIn || first(availableCountriesIn);
        const availableCountriesOut = directions[countryIn];
        const countryOut = calculatorBase.countryOut || first(availableCountriesOut);

        return {
            availableCountriesIn,
            countryIn,
            availableCountriesOut,
            countryOut
        };
    },

    getCurrencies: (getState) => {
        const {currencies, amountIn, countryIn, amountOut, countryOut} = getState().calculator;
        const availableCurrenciesIn = Object.keys(currencies);
        const _amountIn = amountIn ?
            resolver.updateCurrency(availableCurrenciesIn, amountIn, countryIn) :
            resolver.getDefaultAmount(availableCurrenciesIn, 'in');
        const availableCurrenciesOut = currencies[_amountIn.getCurrency];
        const _amountOut = amountOut ?
            resolver.updateCurrency(availableCurrenciesOut, amountOut, countryOut) :
            resolver.getDefaultAmount(availableCurrenciesOut, 'out');

        return {
            availableCurrenciesIn,
            amountIn: _amountIn,
            availableCurrenciesOut,
            amountOut: _amountOut,
        }
    },

    getDelivery: (getState) => {
        const {availableDeliveryMethods, deliveryMethod} = getState().calculator;
        const {showSpecialOffer} = provider.declareSettings();
        const {product}= provider.init;
        const definedMethod = find(availableDeliveryMethods, method => method.name === product);

        if (definedMethod) {
            availableDeliveryMethods[product].enabled = true;
        }

        const methodDefinedByAdmin = definedMethod && definedMethod.enabled ? definedMethod : false;
        const currentSelectedMethod = deliveryMethod && find(availableDeliveryMethods, deliveryMethod) ? deliveryMethod : false;
        const firstAvailableMethod = first(filter(availableDeliveryMethods, {enabled: true}));

        const method = (methodDefinedByAdmin || currentSelectedMethod || firstAvailableMethod) ||  new DeliveryMethod();

        const firstTransferFee = method.fee && method.fee.firstTransfer;
        const standardFee = method.fee && method.fee.standard;
        const fee = (showSpecialOffer && firstTransferFee) || standardFee;

        return {method, fee};
    }
};
